<div class="ct-overlay">
  <div class="ct-modal">
    <img class="cm-icon" src="assets/icons/error-triangle.svg" alt="" />
    <p class="cm-msg-one" *ngIf="!errorMSg">{{ "Error" | translate }}</p>
    <p class="cm-msg-two">{{ (errorMSg ? errorMSg :"OopsSomethingWentWrong") | translate }}</p>
    <div class="cm-btn-grp">
      <button (click)="onClickRefresh()" class="cm-btn-dark" *ngIf="!errorMSg">
        {{ "Refresh" | translate }}
        <img class="arrow-right-icon" src="assets/icons/arrow-right.svg" alt="error" />
      </button>
      <button (click)="closeModal()" *ngIf="errorMSg" class="cm-btn-dark">{{"OK" | translate}}</button>

    </div>
  </div>
</div>
